import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { Box, Text, Tag } from "../ui";
import { formatOrderNumber } from "./utils";

const ShopTransactionCard = ({ orderDate, orderId, productList, tagStyle, price, status }) => (
    <Container>
        <Box gap="16px">
            <Box flexDirection={["column", "row"]} gap={["16px", "32px"]} alignItems={["", "center"]}>
                <Text as="h4" fontSize="22px" fontWeight={700} fontFamily="AnPostSansBold">
                    {orderDate} | Shop
                </Text>
                <Text fontSize="14px" lineHeight="24px">
                    Order reference:{" "}
                    <strong>
                        <span style={{ fontWeight: 700, fontSize: "14px", lineHeight: "24px" }}>{formatOrderNumber(orderId)}</span>
                    </strong>
                </Text>
            </Box>
            <Box gap="24px">
                <Box flexDirection={["column", "row"]} gap={["16px", ""]}>
                    <Box>
                        {productList.items.map((product, i) => {
                            return <Text key={i}>{`${product}`}</Text>;
                        })}
                    </Box>
                    {!!productList.moreItemsCount && (
                        <Text fontWeight={700} color="#757575" marginLeft={[0, "16px"]} alignSelf={["flex-start", "flex-end"]}>
                            +{productList.moreItemsCount} more items
                        </Text>
                    )}
                </Box>
                <div>
                    <Tag backgroundColor={tagStyle.backgroundColor} dotColor={tagStyle.dotColor}>
                        {status}
                    </Tag>
                </div>
            </Box>
        </Box>
        <Box flexDirection={["row", "column"]} justifyContent={["space-between"]} alignItems={["center"]}>
            <Box gap={["1.6rem", "4rem"]} flexDirection={["column", "row-reverse"]} alignItems={["flex-start", "center"]}>
                <Box background="#F3F3F3" padding="12px 16px" borderRadius="5px">
                    <Text as="span" fontSize={["18px", "20px"]} fontFamily="AnPostSansBold">
                        {price}
                    </Text>
                </Box>
            </Box>
            <Link to={`/Transactions/shop?orderId=${orderId}&page=transactions-history`} style={{ textDecoration: "none" }}>
                <Text as="span" alignItems="center" display="flex" gap="8px" fontFamily="AnPostSansBold" color="#008755" fontSize={["14px", "16px"]}>
                    Details <ArrowRightIcon />
                </Text>
            </Link>
        </Box>
    </Container>
);

const ArrowRightIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.79387 2.34221C9.18439 1.95169 9.81756 1.95169 10.2081 2.34221L15.2081 7.34221C15.5986 7.73273 15.5986 8.3659 15.2081 8.75642L10.2081 13.7564C9.81756 14.1469 9.18439 14.1469 8.79387 13.7564C8.40335 13.3659 8.40335 12.7327 8.79387 12.3422L12.0868 9.04932H2.50098C1.94869 9.04932 1.50098 8.6016 1.50098 8.04932C1.50098 7.49703 1.94869 7.04932 2.50098 7.04932H12.0868L8.79387 3.75642C8.40335 3.3659 8.40335 2.73273 8.79387 2.34221Z"
            fill="#008755"
        />
    </svg>
);

const Container = ({ children }) => (
    <Box
        border="1px solid #CFD0CF"
        borderRadius="5px"
        padding={["16px", "24px"]}
        display="flex"
        flexDirection={["column", "row"]}
        gap="16px"
        justifyContent={["flex-start", "space-between"]}
        width="100%"
    >
        {children}
    </Box>
);

export default ShopTransactionCard;

ShopTransactionCard.propTypes = {
    orderDate: PropTypes.string,
    productList: PropTypes.object,
    tagStyle: PropTypes.object,
    price: PropTypes.string,
    status: PropTypes.string
};
